import { render, staticRenderFns } from "./HistoryGift.vue?vue&type=template&id=0a8bc11a&scoped=true"
import script from "./HistoryGift.vue?vue&type=script&lang=js"
export * from "./HistoryGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8bc11a",
  null
  
)

export default component.exports